import { __read } from "tslib";
import React, { useState, useEffect } from 'react';
import { useDispatch } from "react-redux";
import { Modal } from './Modal';
export var EditLineDiscountModal = function (props) {
    var shouldHide = props.shouldHide, show = props.show, order = props.order, onChangeDiscount = props.onChangeDiscount;
    var dispatch = useDispatch();
    var _a = __read(useState(0), 2), lineDiscount = _a[0], setLineDiscount = _a[1];
    var textInput = React.createRef();
    useEffect(function () {
        props.line && setLineDiscount(props.line.linediscountpct);
        textInput.current && textInput.current.focus();
        textInput.current && textInput.current.select();
    }, []);
    var onClickConfirm = function () {
        if (onChangeDiscount) {
            onChangeDiscount(props.line, lineDiscount);
            shouldHide();
        }
    };
    var onChangeValue = function (e) {
        console.log(e, 'EVENT');
        setLineDiscount(e.target.value);
    };
    var renderModal = function () { return (React.createElement("div", { className: "delete-order-modal" },
        React.createElement("div", { style: { padding: '20px' } },
            React.createElement("h2", null, "Set line discount for item"),
            React.createElement("div", { className: "form-control" },
                React.createElement("input", { ref: textInput, type: "number", name: "salespersonNote", value: lineDiscount, onChange: onChangeValue, placeholder: 'Line discount', max: 100, min: 0, onKeyDown: function (event) { return event.key === 'Enter' && onClickConfirm(); } }))),
        React.createElement("div", { className: "delete-order-modal__footer" },
            React.createElement("button", { className: "btn", onClick: function () { return onClickConfirm(); } }, "Update discount"),
            React.createElement("button", { className: "btn", onClick: function () { return shouldHide(); } }, "Cancel")))); };
    return (React.createElement(Modal, { children: renderModal(), size: 'sm', hide: shouldHide, isShowing: show, bodyClasses: 'confirm-modal', hideFooter: true }));
};
//# sourceMappingURL=EditLineDiscountModal.js.map